// @ts-nocheck
// ============================================
// FUNDRAISING FORM - STORE SEARCH INTEGRATION
// ============================================
(() => {
  /**
   * Initialize store-search component event listeners
   * Listen for store:select events and update store email and hidden inputs
   */
  function initializeStoreSearchListeners() {
    const storeSearchElement = document.querySelector('.christmas-fundraising-form store-search');
    if (!storeSearchElement) {
      // Wait for store-search element to appear
      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector('.christmas-fundraising-form store-search');
        if (element) {
          obs.disconnect();
          setupStoreSearchEventListeners(element);
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(() => observer.disconnect(), 10000);
      return;
    }
    setupStoreSearchEventListeners(storeSearchElement);
  }

  /**
   * Setup event listeners for store-search component
   * @param {HTMLElement} storeSearchElement - store-search element
   */
  function setupStoreSearchEventListeners(storeSearchElement) {
    console.log('[Fundraising Form] Setting up store-search event listeners');
    // Listen for store:select event (when location is selected)
    storeSearchElement.addEventListener('store:select', (event) => {
      console.log('[Fundraising Form] store:select event received:', event.detail);
      const locationData = event.detail?.location;
      if (!locationData) {
        console.warn('[Fundraising Form] No location data in event');
        return;
      }
      console.log('[Fundraising Form] Location data:', locationData);
      updateStoreEmailFromStoreSearch(locationData);
      updateSelectedStoreNameFromStoreSearch(locationData);
    });
    // Listen for store:deselect event (when location is removed)
    storeSearchElement.addEventListener('store:deselect', (event) => {
      console.log('[Fundraising Form] store:deselect event received:', event.detail);
      clearStoreEmail();
    });
    // Listen for store:clear event (when all locations are cleared)
    storeSearchElement.addEventListener('store:clear', () => {
      console.log('[Fundraising Form] store:clear event received');
      clearStoreEmail();
      clearSelectedStoreName();
    });
  }

  /**
   * Update store email field from store-search location data
   * @param {Object} locationData - Location data from store:select event
   */
  function updateStoreEmailFromStoreSearch(locationData) {
    const emailInput = document.querySelector('.bakers-store-email input');
    console.log('[Fundraising Form] Email input found:', emailInput);
    if (emailInput instanceof HTMLInputElement) {
      const storeEmail = locationData.email || '';
      console.log('[Fundraising Form] Setting store email to:', storeEmail);
      emailInput.value = storeEmail;
    } else {
      console.warn('[Fundraising Form] Email input not found or invalid');
    }
  }

  /**
   * Update selected-store-name hidden input from store-search location data
   * @param {Object} locationData - Location data from store:select event
   */
  function updateSelectedStoreNameFromStoreSearch(locationData) {
    // Find label[data-label=bakery-name] and update next sibling hidden input
    const bakeryNameLabel = document.querySelector('label[data-label="bakery-name"]');
    if (bakeryNameLabel) {
      const hiddenInput = bakeryNameLabel.nextElementSibling;
      if (hiddenInput && hiddenInput.tagName === 'INPUT' && hiddenInput.type === 'hidden') {
        const storeName = locationData.metafield?.value || locationData.name || '';
        console.log('[Fundraising Form] Setting bakery name to:', storeName);
        hiddenInput.value = storeName;
      } else {
        console.warn('[Fundraising Form] Hidden input not found after bakery-name label');
      }
    } else {
      console.warn('[Fundraising Form] Label with data-label="bakery-name" not found');
    }
  }

  /**
   * Clear store email field
   */
  function clearStoreEmail() {
    const emailInput = document.querySelector('.bakers-store-email input');
    if (emailInput instanceof HTMLInputElement) {
      emailInput.value = '';
    }
  }

  /**
   * Clear selected-store-name hidden input
   */
  function clearSelectedStoreName() {
    // Find label[data-label=bakery-name] and clear next sibling hidden input
    const bakeryNameLabel = document.querySelector('label[data-label="bakery-name"]');
    if (bakeryNameLabel) {
      const hiddenInput = bakeryNameLabel.nextElementSibling;
      if (hiddenInput && hiddenInput.tagName === 'INPUT' && hiddenInput.type === 'hidden') {
        hiddenInput.value = '';
      }
    }
  }

  /**
   * Parse date string in format "DD-MM-YYYY" to Date object
   * @param {string} dateString - Date string in format "DD-MM-YYYY"
   * @returns {Date|null} Parsed Date object or null if invalid
   */
  function parseDateString(dateString) {
    if (!dateString) return null;
    const parts = dateString.split('-');
    if (parts.length !== 3) return null;
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    const date = new Date(year, month - 1, day);
    if (date.getDate() !== day || date.getMonth() !== month - 1 || date.getFullYear() !== year) {
      return null;
    }
    return date;
  }

  /**
   * Parse time string in format "H:MM AM/PM" to 24-hour format
   * @param {string} timeString - Time string in format "H:MM AM/PM"
   * @returns {Object|null} Object with hour and minute in 24-hour format, or null if invalid
   */
  function parseTimeString(timeString) {
    if (!timeString) return null;
    const cleanTime = timeString.trim().toUpperCase();
    const match = cleanTime.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/);
    if (!match) return null;
    let hour = parseInt(match[1], 10);
    const minute = parseInt(match[2], 10);
    const period = match[3];
    if (isNaN(hour) || isNaN(minute) || hour < 1 || hour > 12 || minute < 0 || minute > 59) {
      return null;
    }
    if (period === 'AM') {
      if (hour === 12) hour = 0;
    } else {
      if (hour !== 12) hour += 12;
    }
    return { hour, minute };
  }

  /**
   * Validate pickup date and time to ensure it's at least 1 minute in the future
   * @param {HTMLFormElement} form - The form element to validate
   * @returns {boolean} True if valid, false if invalid
   */
  function validatePickupDateTime(form) {
    const pickupDateInput = form.querySelector('.pickup-date input');
    const pickupTimeInput = form.querySelector('.pickup-time input');
    if (!pickupDateInput || !pickupTimeInput) {
      return true;
    }
    const dateValue = pickupDateInput.value;
    const timeValue = pickupTimeInput.value;
    if (!dateValue || !timeValue) {
      return true;
    }
    try {
      const date = parseDateString(dateValue);
      if (!date) {
        console.error('Invalid date format:', dateValue);
        return false;
      }
      const time = parseTimeString(timeValue);
      if (!time) {
        console.error('Invalid time format:', timeValue);
        return false;
      }
      const pickupDateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.hour, time.minute);
      if (isNaN(pickupDateTime.getTime())) {
        console.error('Invalid combined date/time:', pickupDateTime);
        return false;
      }
      const minDateTime = new Date(Date.now() + 60000);
      return pickupDateTime >= minDateTime;
    } catch (error) {
      console.error('Error validating pickup date/time:', error);
      return false;
    }
  }

  /**
   * Create and display quantity validation error
   * @param {HTMLFormElement} form - The form element
   * @param {string} errorMessage - Error message to display
   */
  function createQuantityValidationError(form, errorMessage = 'Please select at least one item with a quantity greater than 0.') {
    const existingErrors = form.querySelectorAll('.custom-errors-message');
    existingErrors.forEach(error => error.remove());
    const errors = document.createElement('div');
    errors.className = 'custom-errors-message';
    errors.innerHTML = `<p>${errorMessage}</p>`;
    const quantityInputs = form.querySelectorAll('input[type="number"]');
    const lastQuantityInput = quantityInputs[quantityInputs.length - 1];
    const lastQuantityInputFormControl = lastQuantityInput ? lastQuantityInput.closest('.globo-form-control') : null;
    if (lastQuantityInputFormControl) {
      lastQuantityInputFormControl.appendChild(errors);
    }
  }

  /**
   * Set validation state on pickup time input
   * @param {HTMLFormElement} form - The form element
   * @param {boolean} isValid - Whether the validation passed
   * @param {string} errorMessage - Error message to display if invalid
   */
  function setPickupTimeValidator(form, isValid, errorMessage = 'Invalid pickup time') {
    const pickupTimeContainer = form.querySelector('.pickup-time');
    const pickupDateInput = form.querySelector('.pickup-date input');
    const pickupTimeInput = form.querySelector('.pickup-time input');
    if (!pickupDateInput || !pickupTimeInput) {
      return;
    }
    const formId = form.dataset.id;
    const formElements = Globo.FormBuilder.forms[formId].elements;
    const pickupDateName = pickupDateInput.name;
    const pickupTimeName = pickupTimeInput.name;
    let pickupDateElement = null;
    let pickupTimeElement = null;
    formElements.forEach(group => {
      group.elements.forEach(element => {
        if (element.name === pickupDateName && pickupDateElement === null) {
          pickupDateElement = element;
        }
        if (element.name === pickupTimeName && pickupTimeElement === null) {
          pickupTimeElement = element;
        }
      });
    });
    const isDateRequired = pickupDateElement.required;
    const isTimeRequired = pickupTimeElement.required;
    const dateValue = pickupDateElement.value;
    const timeValue = pickupTimeElement.value;
    if (isDateRequired && !dateValue) {
      return;
    }
    if (isTimeRequired && !timeValue) {
      return;
    }
    const existingErrors = form.querySelector('.pickup-time .messages');
    if (!isValid) {
      existingErrors.innerHTML = '<p class="help-block error">' + errorMessage + '</p>';
      pickupTimeContainer.classList.add('has-error');
      pickupTimeContainer.classList.remove('has-success');
    } else {
      pickupTimeContainer.classList.remove('has-error');
      pickupTimeContainer.classList.add('has-success');
      existingErrors.innerHTML = '';
    }
  }

  /**
   * Initialize custom form validation for globo forms
   * @param {HTMLFormElement} form - The form element to initialize validation for
   */
  function initializeCustomFormValidationForForm(form) {
    const quantityInputs = form.querySelectorAll('input[type="number"]');
    quantityInputs.forEach(input => {
      input.addEventListener('change', function (e) {
        const value = parseInt(input.value || 0, 10);
        if (value > 0) {
          const errors = form.querySelectorAll('.custom-errors-message');
          if (errors.length > 0) {
            errors[0].remove();
          }
        }
      });
    });
    const pickupDateInput = form.querySelector('.pickup-date input');
    const pickupTimeInput = form.querySelector('.pickup-time input');
    if (pickupDateInput && pickupTimeInput) {
      const validatePickup = () => {
        setTimeout(() => {
          const isValid = validatePickupDateTime(form);
          setPickupTimeValidator(form, isValid);
        }, 100);
      };
      pickupDateInput.addEventListener('change', validatePickup);
      pickupTimeInput.addEventListener('change', validatePickup);
    }
    form.addEventListener('submit', function (e) {
      const quantityInputs = form.querySelectorAll('input[type="number"]');
      let hasValue = false;
      let hasValidationErrors = false;
      quantityInputs.forEach(input => {
        if (parseInt(input.value || 0, 10) > 0) hasValue = true;
      });
      if (!hasValue) {
        createQuantityValidationError(form);
        hasValidationErrors = true;
      }
      const isPickupValid = validatePickupDateTime(form);
      if (!isPickupValid) {
        setPickupTimeValidator(form, false, 'Invalid pickup time');
        hasValidationErrors = true;
      } else {
        setPickupTimeValidator(form, true);
      }
      if (hasValidationErrors) {
        // @ts-ignore
        window.Globo.FormBuilder.handleValidate(form);
        if (!isPickupValid) {
          setPickupTimeValidator(form, false, 'Invalid pickup time');
        } else {
          setPickupTimeValidator(form, true);
        }
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });
  }

  function initializeCustomFormValidation() {
    const form = document.querySelector('.globo-form.christmas-fundraising-form form');
    if (form) {
      initializeCustomFormValidationForForm(form);
    }
  }

  // @ts-ignore
  window.onFundraisingFormInitialized = function () {
    initializeStoreSearchListeners();
    initializeCustomFormValidation();
  };
})();
